var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon",class:[_vm.small ? 'small' : '', _vm.flip ? 'flip' : '']},[_c('img',{attrs:{"src":require('@/assets/images/' + _vm.icon),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }